module.exports = __webpack_public_path__ + "kp.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/kp.svg
// module id = 643
// module chunks = 0